import React from 'react';

/** Slide 09 - No data for replay (no credited posts in 2024) */
export const Slide09 = () => (
  <div className="absolute inset-0 h-full w-full">
    <div className="pt-24" />
  </div>
);
